<template lang="html">
    <BaseWidget>
        <template slot="title">{{ $t("dashboardModule.planoTitle") }}</template>
        <template slot="content-desktop"
            ><planoList :key="'2'" :listPlano="planoList"></planoList
        ></template>
        <template slot="content-mobile">
            <swiper :options="swiperOption" ref="mySwiper">
                <!-- slides -->
                <swiper-slide v-for="item in planoList" :key="item.name" class="txtCenter">
                    <div class="swipe-content">
                        <div class="header flexContainer jc-sb">
                            <div class="status uppercase" :class="renderStatus(item.status)">{{ $t("planoList." + renderStatus(item.status)) }}</div>
                            <div class="flexContainer">
                                <img class="lock" v-if="item.isLocked" src="../../../assets/lock_mobile.svg" width="20" alt="lock_mobile.svg" />
                                <img @click="modalComment(item.id);" src="../../../assets/comment_mobile.svg" width="20" alt="lock_mobile.svg" />
                            </div>
                        </div>
                        <div class="title flexContainer jc-sa">
                            <div class="size2of5"><img src="../../../../static/assets/plano.png" alt="plano" width="37" height="61" /></div>
                            <div class="txtLeft uppercase size3of5" @click="openPlano(item.id, item.isLocked);">
                                <h1>{{ item.name }}</h1>
                                <h2>{{ item.campaign.name }}</h2>
                            </div>
                        </div>
                        <div class="infos center txtCenter">
                            <!-- <h3>Presentoir 0102</h3> -->
                            <p><span class="hidden">4 High |</span> {{ item.width }} x {{ item.height }}</p>
                            <p>
                                <span class="ff-bold">{{ $t("planoList.modified") }}:</span> {{ item.modifiedDate }}
                            </p>
                            <p>
                                <span class="ff-bold lowercase">{{ $t("planoList.by") }}:</span> {{ item.modifiedUser.firstname }}
                                {{ item.modifiedUser.lastname }}
                            </p>
                        </div>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </template>
        <template slot="footer">
            <router-link
                to="/template-plano"
                tag="span"
                class="btnCreatPlano btnExp primary-text fright primary-border-color iBlock pointer mobileNot txtCenter"
                v-if="hasAccessCreate('plano_builder')"
                >{{ $t("plano.create") }}</router-link
            >
            <LinkButton :to="{ name: 'Planos', query: getLinkParams({ campaign: selectedCampaign }) }" :text="$t('dashboardModule.seeAllPlanos')" />
        </template>
    </BaseWidget>
</template>

<script lang="js">
import BaseWidget from "@/components/dashboard/BaseWidget";
import planoList from "@/components/planoList/planoList";
import cacheService from "@/services/cache";
import LinkButton from "@/components/dashboard/elements/LinkButton";
import {mapGetters} from "vuex";


export default  {
    components: { LinkButton, BaseWidget, planoList},
    props: {
        swiperOption: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            planoList: [],
            selectedCampaign: cacheService.getCurrentCampaignId(),
        }
    },
    created(){
        // @info add param 'currentCampaignId'
        // because api unknown param "campaign" => /api/v1/1/[campaign]/plano?limit=50
        let params = {
            routeParams: {
                campaign: cacheService.getCurrentCampaignId()
            }
        };
        this.$store.dispatch("planos/search/getResults", params).then(() => {
            let planos = this.getResults(4);
            planos.sort(function(a, b) {
                let date1 = new Date(a.modifiedDate);
                let date2 = new Date(b.modifiedDate);
                return date2.getTime() - date1.getTime();
            });
            this.planoList = planos;
        });
    },
    methods: {
        modalComment(a) {
            this.showModalComment = !this.showModalComment;
            cacheService.set("plano", a);
        },
        openPlano(a, b) {
            cacheService.set("planoLocked", b);
            this.$router.replace("/plano/" + a);
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                if (x[key] !== null) {
                    temp[key] = this.$route.query[key];
                }
            }

            for (let key in x) {
                if (x[key] !== null) {
                    temp[key] = x[key];
                }
            }
            return temp;
        }
    },
    computed: {
        ...mapGetters("planos/search/", {
            getResults: "getResults"
        })
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
header {
    .blockTitle {
        .subtitle {
            font-size: 1.2rem;
            @extend %second-text;
        }
        .btn {
            font-weight: 400;
            text-transform: none;
        }
    }
    .blockAction {
        font-size: 1.4rem;
        a {
            /*background-color: yellow;*/
        }
    }
}
#planoList {
    padding-top: 0;
    .item {
        font-size: 1.4rem;
        background: #f4f4f4;
        margin-bottom: 20px;
        padding: 20px;
        .status {
            padding: 5px 10px;
            max-width: 150px;
            color: #fff;
            font-size: 1.2rem;
            margin-top: 10px;
        }
        .unlock {
            width: 100%;
            margin-top: 3%;
        }
        .titlePlano {
            font-size: 1.6rem;
        }
        .options {
            margin-top: 10px;
            .noborder {
                width: 80px;
            }
        }
        .sm-menu {
            top: 30px;
            left: 0;
            z-index: 5;
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
            .btn {
                font-size: 1.2rem;
            }
        }
        .optionbtn {
            padding: 0px;
        }
        .contextMenu {
            width: 160px;
            text-align: center;
            background-color: #f4f4f4;
            padding: 0 10px;
            button {
                text-align: center;
                margin: 1px;
                border: none;
                background: transparent;
                padding: 5px 0;
                border-radius: 0;
                &.btnStatus {
                    color: white;
                    font-size: 12px;
                    font-family: "Roboto", sans-serif;
                    text-transform: uppercase;
                }
            }
        }
        #infoModal {
            width: 100%;
            height: 100%;
            background: rgba(000, 000, 000, 0.3);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 10;
            .infoContainer {
                width: 400px;
                height: 200px;
                background: #fff;
                border-radius: 3px;
                margin: auto;
                padding: 30px;
                .cross {
                    right: -10px;
                    top: -10px;
                }
                div {
                    width: 250px;
                }
            }
        }
        .lock {
            height: 100%;
            width: 100%;
            background: rgba(244, 244, 244, 0.8);
            z-index: 9;
            .lockScreenLogo {
                width: 23px;
                height: 25px;
                margin: auto;
            }
            .lockText {
                margin: auto;
                font-weight: bold;
            }
        }
        .tooltip {
            width: 92px;
        }
        .borderbottom {
            border-bottom: 1px solid #ccc;
        }
        .noborder {
            border: none;
        }
        .in_progress {
            background-color: #e28200;
        }
        .approved {
            background-color: #8ab400;
        }
        .archived {
            background-color: #a3a3a3;
        }
        .submitted {
            background-color: #41b4e8;
        }
    }
}
.btnCreatPlano {
    margin-right: 20px;
    float: left;
    font-size: 12px;
    padding: 4px 10px;
    text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// PlanoWidget.vue?f40d933c